import React from 'react';
import AddTabPlatform from '@atlassian/jira-navigation-kit-add-tab-old/src/ui/index.tsx';
import { AsyncMenuContent } from './menu-content/async.tsx';

/** @deprecated delete when cleaning up getWillShowNav4, should only be used for nav3 */
export const AddTab = () => <AddTabPlatform menuContent={AsyncMenuContent} />;
